import { EntityActions } from 'utils/actions';
import {
  ENTITY_ACTIVATE_API_URL,
  ENTITY_ARCHIVE_API_URL,
  ENTITY_DEACTIVATE_API_URL,
  ENTITY_UNARCHIVE_API_URL,
} from 'utils/defaults';
import { LiveStatus } from 'utils/statuses';

export const actions = [
  {
    action: EntityActions.ARCHIVE,
    status: LiveStatus.INACTIVE,
    url: ENTITY_ARCHIVE_API_URL,
    color: 'error',
  },
  {
    action: EntityActions.UNARCHIVE,
    status: LiveStatus.ARCHIVED,
    url: ENTITY_UNARCHIVE_API_URL,
  },
  {
    action: EntityActions.ACTIVATE,
    status: LiveStatus.INACTIVE,
    url: ENTITY_ACTIVATE_API_URL,
  },
  {
    action: EntityActions.DEACTIVATE,
    status: LiveStatus.ACTIVE,
    url: ENTITY_DEACTIVATE_API_URL,
    color: 'error',
  },
];
